import React,{useState,useEffect} from 'react'
import HeaderofAdash from '../subComponent/HeaderofAdash'
import SidebarOfAdash from '../subComponent/SidebarOfAdash'
import {Row,Col,Modal,Form} from 'react-bootstrap'
import {AiOutlinePlus} from 'react-icons/ai'
import Dropdown2 from '../../subComponents/CustomSubComponents/Dropdown2'
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import axios from 'axios';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import TextField from '@mui/material/TextField';
import ReactPaginate from 'react-paginate';
import {optionsCampus, optionsClass, optionsShift, optionsSubject, optionsdocumentType, optionsevent, optionssection, optionssession, optionsteacherName, roledrp } from '../../Helper'
import moment from 'moment'
import { classSectionEntryApi } from '../../../utils/AdminDashApi/ClassSectionEntry'
import { TimePicker } from '@mui/x-date-pickers'
import { BsSearch } from 'react-icons/bs'
import { stuOtherInfoApi } from '../../../utils/AdminDashApi/StuOtherInfoApi'
import DocumentsSmBox from './subComponent/DocumentsSmBox'
import Switch from './subComponent/Switch'
import Purplebutton from './subComponent/Purplebutton'
const SettingComp = () => {

   
    const [buttonStates, setButtonStates] = useState({
        button1:false,
        button2:false,
        button3:false,
        button4:false,
        button5:false,
        button6:false,
        button7:false,
        button8:false,
        button9:false,

    });

  const handleButtonStateChange = (buttonId, isChecked) => {
    // Update the state with the new isChecked value for the specific button
    setButtonStates((prevState) => ({
      ...prevState,
      [buttonId]: isChecked,
    }));
  };
  useEffect(()=>{
      console.log(buttonStates)

  },[buttonStates])

  const handlesave=()=>{

  }
   
  return (
      <div className="d-flex flexvaluecomp">

          <SidebarOfAdash />
          <div className="contentpartwidthwrapper">
              <HeaderofAdash head="Setting" />
              <div className="contentofadmindash settingwhite">
                    <ul>
                        <li>
                            <p>
                        Set, if late fee will enable or disable during taking student tuition fee. (Online payment)

                            </p>
                            <Switch id="button1" func={handleButtonStateChange} />
                            
                        </li>
                        <li>
                            <p>Publish first semester assessment results on the student panel. (Enable will publish the result)</p>
                        <Switch id="button2" func={handleButtonStateChange} />
                        </li>
                        <li>
                            <p>Publish second semester assessment results on the student panel. (Enable will publish the result)</p>
                        <Switch id="button3" func={handleButtonStateChange} />
                        </li>
                        <li>
                            <p>Publish first semester exam results on the student panel. (Enable will publish the result)</p>
                        <Switch id="button4" func={handleButtonStateChange} />
                        </li>
                        <li>
                            <p>Publish second semester exam results on the student panel. (Enable will publish the result)</p>
                        <Switch id="button5" func={handleButtonStateChange} />
                        </li>
                        <li>
                            <p>Publish first semester exam results on the student panel. (Pre- O Level & O Level)</p>
                        <Switch id="button6" func={handleButtonStateChange} />
                        </li>
                        <li>
                            <p>Publish second semester exam results on the student panel. (Pre- O Level & O Level)</p>
                        <Switch id="button7" func={handleButtonStateChange} />
                        </li>
                        <li>
                            <p>Student result position in class in first semester show or hide from result card. (Enable will show the position)</p>
                        <Switch id="button8" func={handleButtonStateChange} />
                        </li>
                        <li>
                            <p>Student result position in class in second semester show or hide from result card. (Enable will show the position)</p>
                        <Switch id="button9" func={handleButtonStateChange} />
                        </li>
                    </ul>

                    <div className="savebutton text-center">
                        <Purplebutton clickfunc={handlesave} btnname="Save" w="117px" h="40px" mt="20px"/>
                    </div>
              </div>
          </div>
      </div>
  )
}

export default SettingComp